module.exports = __webpack_public_path__ + "img/eg-8-01.9a107c6c.jpg";